import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import { Link } from 'react-router'
import Style from './index.module.less'
import { LIVE_MANAGE_PATH } from '@constant'

export default class extends Component {
  render() {
    const header = [<Link to={LIVE_MANAGE_PATH}>直播管理</Link>, '查看优秀案例']

    return (
      <HeaderView
        title="优秀案例"
        header={header}
        contentStyle={{ padding: 0 }}
      >
        <div className={Style.content}>
          <img src="https://qnm.hunliji.com/o_1d5lt9jpg1u1c1gce16r11d9ohgue.jpg" />

          <img src="https://qnm.hunliji.com/o_1d5lt9jpg1otd14hpq72tl1bhff.jpg" />
          <img src="https://qnm.hunliji.com/o_1d5lt9jpgdoqt9druvta2vpg.jpg" />
          <img src="https://qnm.hunliji.com/o_1d5lt9jpg126b1sj21ve2ah71c70h.jpg" />
          <img src="https://qnm.hunliji.com/o_1d5lt9jpg1f0lp3egvp193e2ui.jpg" />
          <img src="https://qnm.hunliji.com/o_1d5lt9jpgcrf1o1c7711dn01v4nj.jpg" />
        </div>
      </HeaderView>
    )
  }
}
